import { graphql, useStaticQuery } from 'gatsby';

export interface Icon {
    icon: {
        value: {
            url: string;
            name: string;
        }[];
    };
}
export interface codename {
    codename: string;
}

export interface IconNode {
    node: {
        elements: Icon;
        system: codename;
    };
}

interface IconQuery {
    allKontentItemContentItemResearchIcons: {
        edges: IconNode[];
    };
}

export const usehealthIcons = (): IconNode[] => {
    const icons: IconQuery = useStaticQuery(graphql`
        {
            allKontentItemContentItemResearchIcons(
                filter: { preferred_language: { eq: "default" } }
            ) {
                edges {
                    node {
                        elements {
                            icon {
                                value {
                                    url
                                    name
                                }
                            }
                        }
                        system {
                            codename
                        }
                    }
                }
            }
        }
    `);

    return icons.allKontentItemContentItemResearchIcons.edges;
};
